import { Alert, Button, Spin } from "@arco-design/web-react";
import { Link, useParams } from "react-router-dom";
import { QuoteBudgetEditorPage } from "../../quote_budget";
import { useCustomerQuoteRuntime } from "../runtime/useCustomerQuoteRuntime";

/** 报价来源深链解析精确核价后复用同一页面，查看与写入仍按当前用户权限判断。 */
export function CustomerQuoteBudgetReadonlyPage() {
  const { customerQuoteId = "" } = useParams<{ customerQuoteId: string }>();
  const runtime = useCustomerQuoteRuntime(customerQuoteId);
  const returnTo = `/quote/customer-quotes/${encodeURIComponent(customerQuoteId)}`;
  if (runtime.isLoading) return <Spin tip="正在读取报价来源核价" />;
  if (!runtime.editor || !runtime.editor.budgetOrderId) return <div><Alert type="error" content="无法读取当前报价绑定的核价，请返回报价重试。" /><Link to={returnTo}><Button>返回行程报价</Button></Link></div>;
  return <QuoteBudgetEditorPage budgetOrderId={runtime.editor.budgetOrderId} returnTo={returnTo} />;
}
